import React, { useState, useRef, useEffect } from 'react';
import { IconCheck } from '@tabler/icons-react';
import useClickOutside from 'lib/hooks/useClickOutside';
import { IconChevronDown, IconX } from '@tabler/icons-react';

const InputSelected = ({
  dataOption,
  selected,
  setSelected,
  label,
  required,
  width,
  withClear,
  iconComponent: IconComponent,
  disabled = false,
  costumeClass,
}) => {
  const dropdownRef = useRef(null);
  const [showFilterDate, setShowFilterDate] = useState(false);

  useClickOutside(dropdownRef, () => setShowFilterDate(false));

  const handleSetFilterDate = (item) => {
    setSelected(item);
    setShowFilterDate(false);
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        {label && (
          <div className="flex items-center justify-between gap-1">
            <label className="block text-sm font-medium leading-6 text-gray-900">
              {label ? label : 'Type'}
            </label>
            {required && (
              <label className="block text-xs font-light leading-6 text-gray-400">{`(required)`}</label>
            )}
          </div>
        )}
      </div>
      <div className="relative flex flex-row gap-2 items-center mt-1" ref={dropdownRef}>
        <button
          disabled={disabled}
          type="button"
          onClick={() => setShowFilterDate(!showFilterDate)}
          className={`${width ? width : ''} ${disabled ? 'bg-gray-200' : 'bg-transparent'} ${
            costumeClass ? costumeClass : ''
          } ring-1 ring-inset ring-gray-300 flex flex-row justify-between rounded-md py-1.5 px-3 items-center gap-2 cursor-pointer`}>
          {selected ? (
            <span>{selected.name}</span>
          ) : (
            <span className="text-gray-400">{`Pilih ${label ? label : 'Type'}`}</span>
          )}
          <div>
            {IconComponent ? (
              <IconComponent className="text-gray-500 w-5 h-5" />
            ) : (
              <IconChevronDown className="text-gray-500 w-5 h-5" />
            )}
          </div>
        </button>
        {withClear && selected && (
          <div
            className="cursor-pointer ring-1 ring-inset ring-gray-300 p-1.5 rounded-md"
            onClick={() => setSelected(null)}>
            <IconX className="text-gray-500 w-5 h-5" />
          </div>
        )}
        {showFilterDate && (
          <div className={`${width ? width : ''} absolute top-[40px] z-10`}>
            <div className="bg-white flex flex-col py-1 shadow-lg border rounded-md">
              {dataOption.map((item, idx) => {
                const activeItem = selected?.name === item.name;
                return (
                  <div
                    className={`${
                      activeItem ? 'text-primary-main font-medium' : 'text-black'
                    } cursor-pointer px-4 py-2 flex flex-row items-center justify-start hover:bg-primary-main hover:text-white`}
                    key={idx}
                    onClick={() => handleSetFilterDate(item)}>
                    {item.name} {activeItem && <IconCheck className="ml-1 w-4 h-4" />}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InputSelected;
